function dm_a_03_more_people_stories() {

    var page = 2;
    var currentCategory = '';
    var excludedIds = [];
    var currentPageId = parseInt($('#people-stories-load-more').data('current-page-id'), 10) || 0;

    var excludedIdsAttr = $('#people-stories-load-more').data('exclude-ids');
    if (excludedIdsAttr) {
        excludedIds = String(excludedIdsAttr)
            .split(',')
            .map(function(id) {
                return parseInt(id, 10);
            })
            .filter(function(id) {
                return !isNaN(id);
            });
    }

    function load_people_stories(category, reset = false) {
        if (reset) {
            page = 1;
            $('.people-stories-row').empty();
        }

        $('#people-stories-plus').hide();
        $('#people-stories-spinner').show();

        $.ajax({
            url: people_stories_data.ajaxurl,
            type: 'post',
            data: {
                action: 'load_more_people_stories',
                page: page,
                category: category,
                current_page_id: currentPageId,
                exclude_ids: excludedIds.join(','),
                nonce: people_stories_data.nonce
            },
            success: function(response) {
                if(response.html) {
                    $('.people-row').append(response.html);
                    $('#people-stories-spinner').hide();
                    $('#people-stories-plus').show();
                    page++;
                    if (response.hide_button || $(response.html).length < 3) {
                        $('#people-stories-load-more').addClass('btn-hide-invis');
                    } else {
                        $('#people-stories-load-more').removeClass('btn-hide-invis');
                    }
                } else {
                    $('#people-stories-load-more').addClass('btn-hide-invis');
                    $('#people-stories-spinner').hide();
                    $('#people-stories-plus').show();
                }
            },
            error: function() {
                $('#people-stories-spinner').hide();
                $('#people-stories-plus').show();
            }
        });
    }

    $('#people-stories-load-more').off('click.dmPeopleStories').on('click.dmPeopleStories', function(e) {
        e.preventDefault();
        load_people_stories(currentCategory);
    });

}

export { dm_a_03_more_people_stories };
